import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	loan: null,
	emiHistory: [],
	error: "",
	loading: false,
};

// ADD_overtime
export const addLoan = createAsyncThunk(
	"loan/addLoan",
	async (values, { rejectWithValue }) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `/loan`,
				data: {
					...values,
				},
			});

			// Assuming the backend returns the loan data in case of success
			toast.success("Loan added successfully!");
			return {
				data,
				message: "Loan added successfully!",  // Success message can be passed here
			};
		} catch (error) {
			console.error("Error adding loan:", error);
			toast.error(error.response?.data?.message || "Error in adding loan. Please try again.");
			return rejectWithValue(error.response?.data?.message || "An error occurred");
		}
	}
);

export const addEMI = createAsyncThunk(
	"loan/addLEMI",
	async (values, { rejectWithValue }) => {
		console.log("values", values);
		
		try {
			const { data } = await axios({
				method: "post",
				url: `/loan/Emi`,
				data: {
					...values,
				},
			});

			// Assuming the backend returns the loan data in case of success
			toast.success("Loan added successfully!");
			return {
				data,
				message: "Loan added successfully!",  // Success message can be passed here
			};
		} catch (error) {
			console.error("Error adding loan:", error);
			toast.error(error.response?.data?.message || "Error in adding loan. Please try again.");
			return rejectWithValue(error.response?.data?.message || "An error occurred");
		}
	}
);

// DELETE_overtime
export const deleteLoan = createAsyncThunk(
	"loan/deleteLoan ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `loan/${id}`,
			});

			toast.success("Loan deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting loan try again");
			console.log(error.message);
		}
	}
);


// loan
export const getAllLoan = createAsyncThunk(
	"loan/getAllLoan",
	async () => {
		try {
			const { data } = await axios.get(`loan`);
			return data;
		} catch (error) {
			console.log(error.message);
			return [];
		}
	}
);

export const getSingleLoan = createAsyncThunk(
	"loan/getSingleLoan",
	async (id) => {
		try {
			const { data } = await axios.get(`loan/${id}`);

			return data;
		} catch (error) {
			console.log(error.message);
			return [];
		}
	}
);

export const getLoanByUser = createAsyncThunk(
	"loan/getLoanByUser",
	async (userId) => {
		try {
			const { data } = await axios.get(`loan/${userId}/user`);
			return data;
		} catch (error) {
			console.log(error.message);
			return [];
		}
	}
);

export const updateLoan = createAsyncThunk(
	"loan/updateLoan",
	async ({ id, values }, { rejectWithValue }) => {
		try {
			const { data } = await axios({
				method: "put",
				url: `loan/${id}`,
				data: {
					...values,
				},
			});

			// Assuming backend returns the updated loan data on success
			toast.success("Loan updated successfully!");
			return {
				data,
				message: "Loan updated successfully!",
			};
		} catch (error) {
			console.error("Error updating loan:", error);
			// Displaying error message returned by backend (if available)
			toast.error(error.response?.data?.message || "Error in updating loan. Please try again.");
			return rejectWithValue(error.response?.data?.message || "An error occurred");
		}
	}
);

// Get EMI history for a loan
export const getLoanEMIHistory = createAsyncThunk(
	"loan/getLoanEMIHistory",
	async (loanId) => {
		try {
			const { data } = await axios.get(`loan/${loanId}/emi-history`);
			return data;
		} catch (error) {
			console.log(error.message);
			return [];
		}
	}
);

// Delete EMI entry
export const deleteLoanEMI = createAsyncThunk(
	"loan/deleteLoanEMI",
	async ({ loanId, emiId }, { rejectWithValue }) => {
		try {
			const { data } = await axios.delete(`loan/${loanId}/emi/${emiId}`);
			toast.success("EMI entry deleted successfully!");
			return {
				data,
				message: "success",
				loanId,
				emiId
			};
		} catch (error) {
			console.error("Error deleting EMI:", error);
			toast.error(error.response?.data?.message || "Error deleting EMI entry. Please try again.");
			return rejectWithValue(error.response?.data?.message || "An error occurred");
		}
	}
);

const loanSlice = createSlice({
	name: "loan",
	initialState,
	reducers: {
		clearOvertime: (state) => {
			state.loan = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllLoan ======

		builder.addCase(getAllLoan.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllLoan.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllLoan.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 1) ====== builders for getLoanByUser ======

		builder.addCase(getLoanByUser.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getLoanByUser.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getLoanByUser.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addLoan  ======

		builder.addCase(addLoan.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addLoan.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addLoan.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for addEMI  ======

		builder.addCase(addEMI.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addEMI.fulfilled, (state, action) => {
			state.loading = false;
			// The loan data will be refreshed by calling getAllLoan after EMI recording
			// This ensures the updated balance is reflected in the UI
		});

		builder.addCase(addEMI.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});



		// 3) ====== builders for loan ======

		builder.addCase(updateLoan.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateLoan.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateLoan.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for getSingleLoan ======

		builder.addCase(getSingleLoan.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getSingleLoan.fulfilled, (state, action) => {
			state.loading = false;

			state.overtimeDetail = action.payload;
		});

		builder.addCase(getSingleLoan.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteLoan  ======

		builder.addCase(deleteLoan.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteLoan.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteLoan.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 5) ====== builders for getLoanEMIHistory  ======

		builder.addCase(getLoanEMIHistory.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getLoanEMIHistory.fulfilled, (state, action) => {
			state.loading = false;
			state.emiHistory = action.payload;
		});

		builder.addCase(getLoanEMIHistory.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload?.message || "Failed to load EMI history";
		});

		// 6) ====== builders for deleteLoanEMI  ======

		builder.addCase(deleteLoanEMI.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteLoanEMI.fulfilled, (state, action) => {
			state.loading = false;
			// Remove the deleted EMI from the EMI history
			state.emiHistory = state.emiHistory.filter(emi => emi.id !== action.payload.emiId);
		});

		builder.addCase(deleteLoanEMI.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload?.message || "Failed to delete EMI entry";
		});
	},
});

export default loanSlice.reducer;
export const { clearOvertime } = loanSlice.actions;
